<template>
  <div>
    <div class="banner">
      <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082503080930.jpg"></el-image>
      <div class="cover">
        <h1>诗董中国</h1>
        <div class="subtitle">关于诗董</div>
      </div>
    </div>

    <div class="box">
      <el-row>
        <el-col :span="6">
          <div class="img8">
            <el-image src="/img/c111.jpg"></el-image>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="tbox">
            <h1>诗董中国</h1>
            <p class="intro-text">
              诗董集团在中国的橡胶业务与手套业务，分别由上海诗董贸易有限公司、诗董医疗器械（上海）有限公司独立运营。
            </p>
            <p class="intro-text">
              上海诗董贸易有限公司成立于 2004 年，为诗董集团全资子公司，主营标胶、复合胶、烟片胶、乳胶等集团旗下全品类橡胶产品。
            </p>
            <p class="intro-text">
              诗董医疗器械（上海）有限公司为诗董集团全资子公司，全面负责集团手套产品在华市场运营。诗董手套自 2012 年进入中国市场，依托集团成熟的市场运营经验，结合国内市场需求，凭借稳定的产品品质与品牌服务，在医疗、口腔、工业、科研等领域得到广泛应用，业务覆盖国内多区域，深受广大客户认可。
            </p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index"
}
</script>

<style scoped>
@import url("Index.css");
</style>
